import { colors } from 'utils/constants';

interface IProgressBarProps {
  currentStep: number;
  totalSteps: number;
  showRangeLabels?: boolean;
  showCurrentStep?: boolean;
  showCurrentStepNewDesign?: boolean;
}

const ProgressBar = ({
  currentStep,
  totalSteps,
  showRangeLabels,
  showCurrentStep,
  showCurrentStepNewDesign,
}: IProgressBarProps) => {
  return (
    <div className="progressBar fullWidth">
      {showRangeLabels && (
        <div className="rangeLabels fullWidth flexRow flexSpaceBetween">
          <p>0</p>
          <p>{totalSteps}</p>
        </div>
      )}
      <div className="backgroundBar fullWidth" />
      <div className="filledBar">{showCurrentStep && <p>{currentStep}</p>}</div>
      {showCurrentStepNewDesign && (
        <div className="currentStepPositioner flexLeftAligned">
          <div className="currentStepBox">
            <p className="bold noMargin" style={{ fontSize: '0.9em' }}>
              {currentStep} / {totalSteps}
            </p>
            <p className="italic noMargin" style={{ fontSize: '0.8em' }}>
              entries sold
            </p>
          </div>
        </div>
      )}

      <style jsx>
        {`
          .progressBar {
            position: relative;
            display: flex;
            height: 5px;

            flex-shrink: 0;
          }

          .rangeLabels p {
            margin: 0;
          }

          .rangeLabels {
            margin-top: -30px;
          }

          .backgroundBar,
          .filledBar {
            position: absolute;
            border-radius: 4px;
            left: 0;
          }

          .backgroundBar {
            background-color: ${colors.primaryBrandGray}20;
            height: 3px;
            top: 1px;
          }

          .filledBar {
            width: ${(currentStep * 100) / totalSteps}%;
            height: 5px;
            top: 0;
            background-color: ${colors.primaryBrandGray};
            display: flex;
            justify-content: flex-end;
            transition: 0.8s width;
          }

          .filledBar p {
            margin-top: 7px;
          }

          .currentStepPositioner {
            position: absolute;
            left: max(
              1px,
              calc(
                ${(currentStep * 100) / totalSteps}% -
                  ${(currentStep * 100) / totalSteps > 90 ? '76px' : '38px'}
              )
            );
            right: 0;
            margin-top: 10px;
          }

          .currentStepBox {
            position: relative;
            padding: 0.5em 0.75em;
            color: white;
            background: ${colors.primaryBrandGray};
            border-radius: 8px;
            text-align: center;
          }

          .currentStepBox p {
            margin: 0;
            white-space: nowrap;
            text-align: center;
          }
        `}
      </style>
    </div>
  );
};

export default ProgressBar;
